/**
 * Consultas externas da Task 9 (CNPJ na Receita e CEP), com os caminhos que ela publica (decisão 6):
 * - POST /contacts/lookup, corpo { document } → CnpjData (dentro de /contacts, exige X-Company-Id);
 * - GET /cep/:cep → CepData (módulo /cep; desde a correção de segurança da Task 9 também exige X-Company-Id).
 * As duas passam pelo `api()` da sessão, que já envia a empresa ativa.
 */
export const LOOKUP_CNPJ = "/contacts/lookup";
export const lookupCepPath = (cep: string) => `/cep/${encodeURIComponent(cep)}`;
